import { useCallback, useLayoutEffect, useRef } from 'react';

// Scroll only the conversation pane; scrollIntoView also moves its page ancestors.
export const useInboxScroll = (sessionId, messages) => {
  const threadRef = useRef(null);
  const contentRef = useRef(null);
  const followRef = useRef(true);
  const scrollToLatest = useCallback(() => {
    const thread = threadRef.current;
    if (thread && followRef.current) thread.scrollTop = thread.scrollHeight;
  }, []);
  const onThreadScroll = useCallback(() => {
    const thread = threadRef.current;
    if (thread) followRef.current = thread.scrollHeight - thread.clientHeight - thread.scrollTop < 80;
  }, []);
  useLayoutEffect(() => { followRef.current = true; scrollToLatest(); }, [sessionId, scrollToLatest]);
  useLayoutEffect(scrollToLatest, [messages, scrollToLatest]);
  useLayoutEffect(() => {
    const content = contentRef.current;
    if (!content) return;
    const observer = new ResizeObserver(scrollToLatest);
    observer.observe(content);
    return () => observer.disconnect();
  }, [sessionId, scrollToLatest]);
  return { threadRef, contentRef, onThreadScroll };
};